<div>
  <app-create-comps-li-modal
    [addColTableData]="addColTableData"
    [stdLineItems]="stdLineItems"
    [max]="max"
    [tickers]="tickers"
    [filterData]="filterData"
    [yearTypeData]="YearTypeData"
    [marketItemsData]="marketItemsData"
    (saveYearType)="updateYearType($event)"
    (saveLineItems)="onUpdateComp($event)"
  >
  </app-create-comps-li-modal>
  <div class="comps-name">
    <label>Peer Analysis Table Name:</label>
    <input
      nz-input
      #name
      nzSize="small"
      placeholder="Enter Peer Analysis Table Name"
      [(ngModel)]="compsName"
      (keyup)="onChangeCompsName()"
      maxlength="100"
      [ngClass]="[compsNameInvalid ? 'err-border' : '']"
    />
    <span class="error-color comps-name-error" [hidden]="!compsNameInvalid">
      <va-icon name="exclamation-triangle"></va-icon>
      {{ compsNameError }}</span
    >
  </div>
</div>
